import { render, staticRenderFns } from "./ListaPuesto.vue?vue&type=template&id=e51c312c"
import script from "./ListaPuesto.vue?vue&type=script&lang=js"
export * from "./ListaPuesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports